interface PageFaq {
  question: string;
  answer: string;
}

export const pageFaqs: Record<string, PageFaq[]> = {
  inventory: [
    {
      question: "How many used cars do you have in stock?",
      answer:
        "We have over 400 used cars in stock across all of our locations. You can see our live inventory on the Home page or the Inventory page, and use the search filters to find the exact vehicle you want."
    },
    {
      question: "Do you offer financing?",
      answer:
        "Yes! We work with a range of lenders to provide financing for all credit scores. Our in‑house financing team can get you a pre‑approval within minutes and set you up with a payment plan that fits your budget."
    },
    {
      question: "Do you offer warranties?",
      answer:
        "All of our vehicles come with a free 90‑day/4,000‑mile limited warranty. You can also purchase an extended powertrain or bumper‑to‑bumper warranty for added peace of mind."
    },
    {
      question: "Can I trade in my vehicle?",
      answer:
        "Absolutely! Bring in your vehicle for an appraisal or use our online trade‑in calculator to see what it’s worth."
    },
    {
      question: "Do you deliver vehicles?",
      answer:
        "Yes – we offer free delivery within a 15‑mile radius of our Warrenton location, and we’ll ship anywhere in the US for a nominal fee."
    },
    {
      question: "Can I schedule a test drive?",
      answer:
        "Yes – simply select a date and time directly on the vehicle’s detail page or call us to arrange an appointment."
    },
    {
      question: "Do you sell vehicles online?",
      answer:
        "Yes – you can browse and purchase vehicles entirely online, from credit application to signing the contract."
    },
    // ... (other inventory FAQs)

    {
      question: "What types of vehicles do you have?",
      answer:
        "We sell everything from compact cars and SUVs to pickup trucks, performance cars, and exotic models."
    },
    {
      question: "Do you sell electric cars?",
      answer:
        "Yes – we have a growing selection of EVs, including the Tesla Model 3, Nissan Leaf, and Chevrolet Bolt."
    },
    {
      question: "Are there any special deals right now?",
      answer:
        "Check our “Special Deals” section on the Home page – we regularly run limited‑time promotions on select makes and models."
    },

    {
      question: "Do you have any new cars?",
      answer:
        "Yes – we carry a small selection of new inventory, mostly from manufacturers we partner with for special deals."
    },

    {
      question: "Are your cars inspected?",
      answer:
        "Every vehicle goes through a 150‑point inspection, a detailed CARFAX report, and a test‑drive before it’s listed."
    },

    {
      question: "Do you have any new or used trucks?",
      answer:
        "We have a variety of trucks – from compact midsize trucks to full‑size pickups like the Ford F‑150, Chevrolet Silverado and Ram 1500."
    },

    {
      question: "Do you have any new or used SUVs?",
      answer:
        "Our inventory includes a huge range of SUVs from sub‑compact to full‑size, such as the Toyota RAV4, Honda CR‑V, Subaru Forester, Ford Explorer, Toyota Highlander, & more."
    },

    {
      question: "Do you have any new or used crossovers?",
      answer:
        "Yes – we have a great selection of crossovers, including the Mazda CX‑5, Subaru Crosstrek, Hyundai Tucson, and many others."
    },

    {
      question: "Do you have any new or used sedans?",
      answer:
        "We have a full range of sedans, from compact cars such as the Toyota Corolla and Honda Civic to midsize like the Toyota Camry, Honda Accord and more."
    },

    {
      question: "Do you have any new or used hatchbacks?",
      answer:
        "We have many hatchback options, such as the Toyota Corolla Hatchback, Honda Civic Hatchback, & Mini Cooper."
    },

    {
      question: "Do you have any new or used coupes?",
      answer:
        "We have a selection of coupes and sports cars, such as the Ford Mustang, Chevrolet Camaro, Nissan 350Z and more."
    },

    {
      question: "Do you have any new or used convertibles?",
      answer:
        "We have a few convertibles in stock – the Mazda MX‑5 Miata, Chevrolet Camaro Convertible & Ford Mustang Convertible."
    },

    {
      question: "Do you have any new or used vans?",
      answer:
        "We have a broad selection of vans spanning compact cargo and passenger vans (Ford Transit, Mercedes Sprinter, Nissan NV, and Chevrolet Express)."
    },

    {
      question: "Do you have any new or used luxury cars?",
      answer:
        "Yes – we have a great selection of high‑end luxury cars on both new and used inventory, from brands like BMW, Mercedes‑Benz, Audi and Lexus."
    },

    {
      question: "Do you have any new or used pickup trucks?",
      answer:
        "We have a large range of pickups, from compact midsize trucks to full‑size pickups like the Ford F‑150, Chevrolet Silverado and Ram 1500."
    },

    {
      question: "Do you have any new or used electric or hybrid vehicles?",
      answer:
        "Yes – we have a wide range of EV and hybrid options, ranging from the Tesla Model 3 to the Honda Insight."
    },

    {
      question: "Do you have any new or used off‑road vehicles?",
      answer:
        "Yes – we have many off‑road capable vehicles, from the Jeep Wrangler to Subaru Outback and Toyota 4Runner."
    },

    {
      question: "Do you have any new or used low‑mile vehicles?",
      answer:
        "Yes – we have a selection of low‑mileage vehicles that we call “Certified Low Mileage” (5,000‑15,000 miles)."
    },

    {
      question: "Do you have any new or used high‑mileage vehicles?",
      answer:
        "We have a wide range of high‑mileage vehicles, many of which are well‑maintained and come with a free limited warranty."
    },

    {
      question: "Do you have any new or used classic or collector’s cars?",
      answer:
        "Yes – we have a curated selection of classic cars and collectible vehicles, ranging from classic Mustangs to Porsche 911s."
    },

    {
      question: "Do you have any new or used trucks with a crew cab?",
      answer:
        "Yes – we have a great selection of crew‑cab pickups like the Ford F‑150 SuperCrew, RAM Crew, and Chevrolet Silverado crew cab."
    },

    {
      question: "Do you have any new or used trucks with a double‑cab?",
      answer:
        "Yes – we have a variety of pickups with a double‑cab configuration."
    },

    {
      question: "Do you have any new or used trucks with a regular cab?",
      answer:
        "Yes – we have a good selection of trucks in a regular cab configuration."
    },

    {
      question: "Do you offer pre‑owned vehicles at a discount?",
      answer:
        "All of our pre‑owned vehicles are priced aggressively to provide an excellent value."
    },

    {
      question: "Can I get a “hard pull” check on my credit?",
      answer:
        "Yes – we do a “hard pull” on your credit as part of the financing application to provide you an accurate loan offer. Once you submit an application we will pull your credit report using a hard inquiry."
    },

    {
      question: "Can I get a “soft pull” check on my credit?",
      answer:
        "Yes – we can also do a “soft pull” on your credit as part of an initial qualification step.  You’ll get a pre‑approval estimate based on the soft pull and an accurate loan amount after we do a hard pull when you submit a financing application."
    },

    {
      question: "Is a “soft pull” the same as a “hard pull”?",
      answer:
        "No – a soft pull will not affect your credit score and is used for pre‑qualification only whereas a hard pull will affect you credit score."
    },

    {
      question: "Will a hard pull affect my credit score?",
      answer:
        "Yes – a hard pull does impact your credit score and is required when you submit a loan application that is turned into a credit line."
    },

    {
      question: "Will a soft pull affect my credit score?",
      answer:
        "No – a soft pull does not affect your credit score and is used only for pre‑qualification."
    },
  ],
  brokerServices: [
    {
      question: "How do I become a broker?",
      answer:
        "You can become a broker by completing a short online onboarding questionnaire, providing licensing details, and signing an agreement."
    },
    {
      question: "What does a broker do for me?",
      answer:
        "Our brokers source vehicles from manufacturers and dealers, negotiate better pricing, and provide a seamless purchasing experience."
    },
    {
      question: "How can I get a custom vehicle?",
      answer:
        "Use our custom vehicle request form. A broker will then contact you to discuss details, preferences and availability."
    },
  ],

  communityImpact: [
    {
      question: 'How does Rockhound Auto support Oregon Dog Rescue?',
      answer: `For every vehicle sold, Rockhound Auto donates $100 directly to Oregon Dog Rescue — a no-kill, foster-based shelter serving the Pacific Northwest. No strings attached, automatic with every sale.`,
    },
    {
      question: 'What is Oregon Dog Rescue and how does it operate?',
      answer: 'Oregon Dog Rescue is a 501(c)(3) non-profit, no-kill shelter founded in 2007. They operate entirely through a foster-based model and rely 100% on community donations and adoption fees — no government funding. Every dog is placed in a loving foster home while awaiting adoption.',
    },
    {
      question: 'What is the Puplandia partnership?',
      answer: 'Puplandia is our exclusive dog-friendly vehicle certification program. When you buy a Puplandia-certified vehicle, we donate an additional $50 to Oregon Dog Rescue on top of our standard $100 per-sale commitment — making it $150 total per Puplandia vehicle sold.',
    },
    {
      question: 'Can I donate my military discount to charity instead of using it on my purchase?',
      answer: 'Yes! Our $300 Dog Tag Discount for active military, veterans, and their families can be applied to your purchase price or donated in full to any registered 501(c)(3) charity of your choice — including Oregon Dog Rescue, local animal shelters, or veteran support organizations.',
    },
    {
      question: 'How does the referral donation multiplier work?',
      answer: 'When you refer someone who buys from us, we donate an additional $100 to Oregon Dog Rescue on top of our standard $100 per-sale commitment. You also receive a $300 referral reward, which you can choose to donate as well — making it up to $400 total per referral going to the dogs.',
    },
    {
      question: 'How can I verify that donations are actually being made?',
      answer: 'We publish our total donation amount on our Community Impact page and update it quarterly. Oregon Dog Rescue also acknowledges our partnership publicly on their website and social media. You can contact ODR directly at (503) 974-4944 to verify our ongoing support.',
    },
    {
      question: 'What impact has Rockhound Auto made so far?',
      answer: 'Since launching our partnership with Oregon Dog Rescue, we have donated over $25,000 and helped fund the rescue, medical care, and rehoming of hundreds of dogs across Oregon and Washington. Every vehicle sale directly contributes to saving more lives.',
    },
    {
      question: 'Can I volunteer or donate directly to Oregon Dog Rescue?',
      answer: 'Absolutely! Visit oregondogrescue.org to learn about volunteer opportunities, foster programs, and direct donation options. Every bit helps — whether you adopt, foster, donate, or simply spread the word about adoptable dogs in need.',
    },
  ],

  carsUnder10k: [
    {
      question: 'Do you really have cars under $10,000?',
      answer: 'Yes — we regularly stock quality used vehicles priced under $10,000. Inventory changes frequently, so check our live listings for the most current options.',
    },
    {
      question: 'Are cheap used cars reliable?',
      answer: 'Every vehicle we sell — regardless of price — goes through a full safety inspection. We only list cars that pass our standards. You also get a free CarFax report with every vehicle.',
    },
    {
      question: 'Can I finance a car under $10k?',
      answer: 'Absolutely. We work with lenders who finance all credit situations, including lower-priced vehicles. Call us or apply online to get pre-approved.',
    },
    {
      question: 'Do you deliver cars under $10,000?',
      answer: `Yes — free delivery within 50 miles of Warrenton, OR. Call us at (855) 468-6348 to arrange delivery.`,
    },
  ],

  carsUnder30k: [
    {
      question: 'What kinds of vehicles are available under $30,000?',
      answer: 'Our under-$30k inventory includes sedans, SUVs, trucks, and crossovers from reliable brands like Toyota, Honda, Subaru, Ford, and Chevrolet. Many are low-mileage and late-model.',
    },
    {
      question: 'Do you offer financing on vehicles under $30,000?',
      answer: 'Yes — we work with multiple lenders to find the best rate for your situation. All credit types welcome. Apply online or call us to get started.',
    },
    {
      question: 'Is there a doc fee on these vehicles?',
      answer: 'Our doc fee is a flat $250 — one of the lowest in Oregon. No hidden fees, no surprises at signing.',
    },
    {
      question: 'Can I trade in my current car toward a vehicle under $30k?',
      answer: 'Yes! We accept trade-ins on all purchases. Use our online trade-in estimator or bring your vehicle in for a free appraisal.',
    },
  ],

  contact: [
    {
      question: 'Where is Rockhound Auto located?',
      answer: 'We are located at 1425 SE 9th St, Warrenton, OR 97146 — just minutes from Astoria and Seaside on the Oregon Coast. We operate by appointment only to ensure you get our full, undivided attention when you visit.',
    },
    {
      question: 'What are your hours of operation?',
      answer: 'We operate by appointment Monday through Saturday, 9 AM to 6 PM. Call or text (855) 468-6348 anytime to schedule a visit that works for your schedule. We are flexible and can often accommodate evening and Sunday appointments with advance notice.',
    },
    {
      question: 'Do I need an appointment to see a vehicle or visit your lot?',
      answer: 'Yes — we are appointment-only, which means you get our full, undivided attention when you visit. No waiting around, no high-pressure sales tactics, no competing with other customers. Just you, the vehicle, and honest answers to your questions.',
    },
    {
      question: 'Can I buy a vehicle entirely online without visiting in person?',
      answer: 'Absolutely. You can browse inventory, apply for financing, review all vehicle details and photos, complete the purchase agreement, and arrange delivery — all online. We offer free delivery within 50 miles of Warrenton, and we can ship anywhere in the continental US.',
    },
    {
      question: 'How quickly do you respond to inquiries?',
      answer: 'We aim to respond to all calls, texts, emails, and contact form submissions within 2 hours during business hours, and within 24 hours on evenings and weekends. If you need immediate assistance, call or text (855) 468-6348.',
    },
    {
      question: 'Do you offer delivery to my location?',
      answer: 'Yes — we offer free delivery within 50 miles of Warrenton, OR, which covers Astoria, Seaside, Cannon Beach, Tillamook, and parts of Southwest Washington. For locations beyond 50 miles, we can arrange paid delivery or shipping anywhere in the US.',
    },
    {
      question: 'I live in Washington state — can I still buy from you?',
      answer: 'Yes! We serve buyers throughout Southwest Washington including Vancouver, Longview, Kelso, Ilwaco, and Long Beach. We handle all out-of-state paperwork and title transfers. Washington residents will owe Washington state use tax when registering the vehicle at home, and we will walk you through the process.',
    },
    {
      question: 'What is the best way to contact you?',
      answer: 'Call or text (855) 468-6348 for the fastest response. You can also email us at hello@rockhoundauto.com or use the contact form on this page. We respond to all inquiries promptly and are here to help with any questions.',
    },
  ],

  financing: [
    {
      question: 'Do you offer financing for bad credit or no credit?',
      answer: 'Yes — we work with a network of lenders who specialize in all credit situations including bad credit, no credit, bankruptcy, and credit rebuilding. Everyone deserves reliable transportation, and we will work hard to get you approved with terms that fit your budget.',
    },
    {
      question: 'How do I apply for financing?',
      answer: 'You can apply online through our secure financing application in under 5 minutes, or call us at (855) 468-6348 and we will walk you through it over the phone. Most applicants receive a credit decision within minutes, and we can often finalize approval same-day.',
    },
    {
      question: 'What is your documentation fee?',
      answer: 'Our doc fee is a flat $250 — period. No hidden fees, no surprises at signing. For comparison, Oregon dealers average $500–$1,200 in doc fees. We keep it simple, transparent, and fair.',
    },
    {
      question: 'Do you mark up interest rates?',
      answer: 'No. We do not mark up financing rates — ever. We shop your loan to multiple lenders, find the best rate available for your credit profile, and pass that rate directly to you with zero markup. What the lender approves is what you pay.',
    },
    {
      question: 'Can first-time buyers get financing?',
      answer: 'Absolutely. We have lenders who specifically work with first-time buyers and understand that everyone has to start somewhere. We will walk you through the entire process, explain your options, and help you build credit while getting into a reliable vehicle.',
    },
    {
      question: 'How fast can I get approved for financing?',
      answer: 'Most applicants receive a credit decision within minutes of submitting an application. If additional documentation is needed, we can often finalize approval the same day. Once approved, you can pick up or have your vehicle delivered as soon as the next business day.',
    },
    {
      question: 'Do you work with credit unions or only traditional lenders?',
      answer: 'We work with both credit unions and traditional lenders. If you have a pre-approval from your own credit union, we are happy to work with them. We can also shop your loan to our network of lenders to see if we can beat your credit union rate — no obligation.',
    },
    {
      question: 'Can I refinance my current auto loan through you?',
      answer: 'Yes — if you have an existing auto loan with a high interest rate, we can help you refinance to a lower rate and potentially lower your monthly payment. Contact us at (855) 468-6348 to discuss your current loan and see if refinancing makes sense for you.',
    },
    {
      question: 'What documents do I need to apply for financing?',
      answer: 'You will need a valid driver\'s license or state ID, proof of income (recent pay stubs, bank statements, or tax returns), proof of residence (utility bill or lease agreement), and proof of insurance. We will guide you through exactly what is needed once you start the application.',
    },
    {
      question: 'Do you offer in-house financing or only third-party lenders?',
      answer: 'We work exclusively with third-party lenders to ensure you get the best rate and terms available. We do not offer in-house "buy here, pay here" financing, which often comes with inflated interest rates and predatory terms. Our goal is to get you a fair, competitive loan.',
    },
  ],

  howItWorks: [
    {
      question: 'How is Rockhound Auto different from a regular dealership?',
      answer: 'We are a broker-style dealer — no high-pressure sales floor, no inflated fees, no games. We source quality vehicles, inspect them thoroughly, and sell them at honest prices with a flat $250 doc fee.',
    },
    {
      question: 'Do I have to come in person?',
      answer: 'No — you can browse, apply for financing, and complete your purchase entirely online. We offer free delivery within 50 miles of Warrenton, OR.',
    },
    {
      question: 'What happens after I find a vehicle I like?',
      answer: 'Contact us to confirm availability, get pre-approved for financing if needed, and we will handle the paperwork. You can pick it up or have it delivered.',
    },
    {
      question: 'Do you offer test drives?',
      answer: 'Yes — schedule a test drive by appointment at our Warrenton location, or in some cases we can bring the vehicle to you.',
    },
  ],

  reviews: [
    {
      question: 'How do I leave a review for Rockhound Auto?',
      answer: 'You can submit a review directly on our Reviews page, or leave a Google review using the link on our contact page. We appreciate every piece of feedback.',
    },
    {
      question: 'Are your reviews verified?',
      answer: 'Yes — we only publish reviews from verified customers who have purchased a vehicle or used our services. No fake reviews, ever.',
    },
    {
      question: 'What if I had a bad experience?',
      answer: `We want to make it right. Contact us directly at hello@rockhoundauto.com or call (855) 468-6348 and we will address your concern personally.`,
    },
  ],

  sellYourCar: [
    {
      question: 'How do I sell my car to Rockhound Auto?',
      answer: 'Fill out our online sell form with your vehicle details and we will get back to you with an offer within 24 hours. No obligation, no pressure.',
    },
    {
      question: 'What types of vehicles do you buy?',
      answer: 'We buy cars, trucks, SUVs, and vans of all makes and models — running or not, high mileage, older models, and vehicles with cosmetic damage.',
    },
    {
      question: 'How fast will I get paid?',
      answer: 'Once we agree on a price and complete the paperwork, payment is typically same-day or next business day.',
    },
    {
      question: 'Do you handle the title transfer?',
      answer: 'Yes — we handle all DMV paperwork, title transfers, and lien payoffs. You just sign and get paid.',
    },
    {
      question: 'Can you pick up my vehicle?',
      answer: 'Yes — we offer free vehicle pickup throughout the Oregon Coast and Southwest Washington.',
    },
  ],

  soldVehicles: [
    {
      question: 'Can I find a vehicle similar to one that was sold?',
      answer: 'Yes — use our Deal Radar feature to get notified when a similar vehicle arrives. You can also submit a custom vehicle request and we will source one for you.',
    },
    {
      question: 'How quickly do vehicles sell?',
      answer: 'Popular vehicles often sell within days. Sign up for First Dibs alerts to be notified the moment a new vehicle matching your criteria is listed.',
    },
    {
      question: 'Do sold vehicles show the final sale price?',
      answer: 'Yes — we display sold prices for transparency so you can see real market data and know you are getting a fair deal on your next purchase.',
    },
  ],

  tradeIn: [
    {
      question: 'How do I get a trade-in value for my car?',
      answer: 'Use our online trade-in estimator for an instant ballpark, or bring your vehicle in for a free in-person appraisal. We use real market data to give you a fair offer.',
    },
    {
      question: 'Is your trade-in offer competitive?',
      answer: 'Yes — we use live market data and aim to beat or match dealer trade-in offers. We want your business and will work to make the numbers work.',
    },
    {
      question: 'Can I trade in a vehicle with a loan on it?',
      answer: 'Yes — we handle lien payoffs as part of the trade-in process. If your trade-in value exceeds the payoff amount, the difference is applied to your new purchase.',
    },
    {
      question: 'Do I have to buy a car to trade mine in?',
      answer: 'No — we will buy your vehicle outright even if you are not purchasing from us. Just fill out the trade-in form and we will make you an offer.',
    },
  ],

  usedCarsAstoriaOregon: [
    {
      question: 'Do you serve buyers in Astoria, Oregon?',
      answer: 'Yes — we are located just minutes from Astoria in Warrenton, OR. We also offer free delivery to Astoria and surrounding areas.',
    },
    {
      question: 'Can I get financing in Astoria?',
      answer: 'Absolutely. We work with lenders across Oregon and Washington. Apply online or call us — all credit types welcome.',
    },
    {
      question: 'Do you have AWD vehicles for Oregon Coast weather?',
      answer: 'Yes — we regularly stock AWD and 4WD vehicles well-suited for Oregon Coast driving conditions. Filter by drivetrain on our inventory page.',
    },
  ],

  usedCarsSWWashington: [
    {
      question: 'Do you sell cars to Washington state buyers?',
      answer: 'Yes — we serve buyers throughout Southwest Washington including Vancouver, Longview, Kelso, Ilwaco, and Long Beach. We handle all out-of-state paperwork.',
    },
    {
      question: 'Do Washington residents pay sales tax when buying from Oregon?',
      answer: 'Yes — Washington residents pay Washington state use tax when they register the vehicle at their local DOL. Where you register is where the taxes apply, no exceptions. The real advantage of buying from us is our flat $250 doc fee, transparent pricing, and no dealer markup games.',
    },
    {
      question: 'Do you deliver to Southwest Washington?',
      answer: 'Yes — we offer delivery to many Southwest Washington locations. Contact us to confirm delivery availability for your area.',
    },
  ],

  usedCarsWarrentonOregon: [
    {
      question: 'Where exactly is Rockhound Auto in Warrenton?',
      answer: 'We are located at 1425 SE 9th St, Warrenton, OR 97146. We operate by appointment — call (855) 468-6348 to schedule a visit.',
    },
    {
      question: 'Do you have inventory available in Warrenton right now?',
      answer: 'Yes — browse our live inventory online. Stock changes frequently so check back often or sign up for Deal Radar alerts.',
    },
    {
      question: 'Do Warrenton buyers get free delivery?',
      answer: 'If you prefer, we can deliver your vehicle directly to your home in Warrenton at no charge.',
    },
  ],

  usedSuvsWarrentonOregon: [
    {
      question: 'What types of SUVs do you have in Warrenton?',
      answer: 'We stock a wide range of SUVs including compact crossovers like the Toyota RAV4 and Honda CR-V, midsize SUVs like the Ford Explorer and Toyota Highlander, and full-size SUVs like the Chevrolet Tahoe.',
    },
    {
      question: 'Do you have AWD or 4WD SUVs for Oregon Coast weather?',
      answer: 'Yes — most of our SUV inventory includes AWD or 4WD options, perfect for Oregon Coast rain and winter conditions. Filter by drivetrain on our inventory page.',
    },
    {
      question: 'Can I finance an SUV in Warrenton?',
      answer: 'Absolutely. We work with lenders who finance all credit situations. Apply online or call us at (855) 468-6348 to get pre-approved.',
    },
    {
      question: 'Do you deliver SUVs to Warrenton buyers?',
      answer: 'Yes — free delivery within 50 miles of our location, which includes all of Warrenton and surrounding areas.',
    },
  ],

  usedTrucksWarrentonOregon: [
    {
      question: 'What types of trucks do you have available in Warrenton?',
      answer: 'We carry a full range of trucks from compact midsize models like the Toyota Tacoma and Ford Ranger to full-size pickups like the Ford F-150, Chevrolet Silverado, and Ram 1500.',
    },
    {
      question: 'Do you have 4WD trucks for towing and hauling?',
      answer: 'Yes — many of our trucks come with 4WD, towing packages, and heavy-duty suspensions. Check the vehicle details page for towing capacity and payload specs.',
    },
    {
      question: 'Can I trade in my old truck toward a newer one?',
      answer: 'Yes! We accept trade-ins on all purchases. Use our online trade-in estimator or bring your truck in for a free appraisal.',
    },
    {
      question: 'Do you offer financing on used trucks?',
      answer: 'Yes — we work with multiple lenders to find the best rate for your situation. All credit types welcome. Apply online or call (855) 468-6348.',
    },
  ],

  videos: [
    {
      question: 'Where can I watch Rockhound Auto vehicle videos?',
      answer: 'All our vehicle walkaround videos are available on this page, on our YouTube channel, and on TikTok @rockhoundauto.',
    },
    {
      question: 'Do you film every vehicle?',
      answer: 'We aim to film every vehicle in our inventory so you can see exactly what you are getting before you visit or buy. No surprises.',
    },
    {
      question: 'Can I request a video of a specific vehicle?',
      answer: `Yes — contact us at (855) 468-6348 or hello@rockhoundauto.com and we will film a walkthrough of any vehicle you are interested in.`,
    },
  ],
};